import { MessageService } from './../../../services/message.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Ship } from '../../../Ship';
import { EntitlementService } from '../../../services/entitlement.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as fleetValidator from '../../../validators/ship-validator';
import { ShipRoundTripInfo } from '../../../data/ShipRoundTripInfo';
import { ShipService } from '../../../services/ship.service';

@Component({
  selector: 'app-fleet-information',
  templateUrl: './fleet-information.component.html',
  styleUrls: ['./fleet-information.component.css']
})
export class FleetInformationComponent implements OnInit {
  @Input() ship: Ship;
  @Output() shipDataChange = new EventEmitter<Ship>();
  save_fl_btn = false;
  save_fl_btn_spinner = '';
  roundTripForm: UntypedFormGroup;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.initForm();
    this.roundTripForm.statusChanges.subscribe((newStatus: string) => {
      this.save_fl_btn = newStatus === 'INVALID';
    });
  }

  initForm() {
    this.roundTripForm = new UntypedFormGroup({
      port: new UntypedFormControl(this.ship.shipPort, [
        Validators.required,
        fleetValidator.roundTripHomeportValidator
      ]),
      dssn: new UntypedFormControl(this.ship.dssn, [
        Validators.required,
        fleetValidator.roundTripDSSNValidator
      ]),
      tycom: new UntypedFormControl(this.ship.shipTycom, [Validators.required]),
      cinc: new UntypedFormControl(this.ship.shipCinc, [Validators.required])
    });
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  updateShipData(newShip: Ship) {
    this.ship = newShip;
  }

  saveFleetInformation() {
    // Start of save
    this.save_fl_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_fl_btn = true;

    const roundTripInfo = new ShipRoundTripInfo();
    roundTripInfo.autoRoundTripInterval = this.ship.autoRoundTripInterval;
    roundTripInfo.skipClinkInd = this.ship.skipClinkInd;
    roundTripInfo.dssn = this.roundTripForm.value['dssn'];
    roundTripInfo.shipCinc = this.roundTripForm.value['cinc'];
    roundTripInfo.shipPort = this.roundTripForm.value['port'];
    roundTripInfo.shipTycom = this.roundTripForm.value['tycom'];

    // Post the data
    this.shipService
      .postShipRoundtripInfo(this.ship.shipLocation, roundTripInfo)
      .subscribe(
        (data: ShipRoundTripInfo) => {
          this.save_fl_btn_spinner = '';
          this.messageService.success('Updated Successfully');
          this.ship.dssn = data.dssn;
          this.ship.shipCinc = data.shipCinc;
          this.ship.shipPort = data.shipPort;
          this.ship.shipTycom = data.shipTycom;
          this.shipDataChange.emit(this.ship);
        },
        error => {
          this.messageService.error(error.message);
        },
        () => {
          this.save_fl_btn_spinner = '';
          this.save_fl_btn = false;
        }
      );
  }
}
